import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect } from "react";
import { useAdminAuthNeeded } from "./admin-login-guard";
import { useAmILoggedIn } from "./api-docs";

// Urls that will not have intercom
const noIntercomUrls = [
  //new RegExp("^/v2/app/[a-zA-Z0-9-]+/registration/.*"), // Employer/Student registration pages serendipitous
  //new RegExp("^/v2/app/[a-zA-Z0-9-]+/events/serendipitous/[0-9]+/student/.*"), // Student video chat experience serendipitous
  //new RegExp("^/v2/app/[a-zA-Z0-9-]+/events/serendipitous/[0-9]+/employer/.*"), // Employer video chat experience serendipitous
  new RegExp(
    "^/v2/app/[a-zA-Z0-9-]+/admin/events/serendipitous/[0-9]+/edit/.*",
  ),
  new RegExp("^/v2/app/[a-zA-Z0-9-]+/admin/events/serendipitous/create-event"),
  new RegExp("^/v2/app/[a-zA-Z0-9-]+/jobs/.*"), // careers page for ats
  new RegExp("^/v2/app/[a-zA-Z0-9-]+/jobs"), // careers page for ats
  new RegExp("^/v2/app/forward/firms/.*"), // iFramed firm profiles from WebFlow
];

const setIntercomVars = (name, email) => {
  if (process.browser) {
    try {
      // @ts-ignoreå
      Intercom("update", { name: name, email: email });
    } catch (error) {
      /* empty */
    }
  }
};

const updateIntercomStatus = (enabled) => {
  if (process.browser) {
    try {
      // @ts-ignoreå
      Intercom("update", {
        // eslint-disable-next-line camelcase
        hide_default_launcher: !enabled,
      });
    } catch (error) {
      /* empty */
    }
  }
};

const checkPath = () => {
  let renderIntercom = false;
  if (process.browser) {
    renderIntercom = true;
    for (let i = 0; i < noIntercomUrls.length; i++) {
      if (window.location.pathname.match(noIntercomUrls[i])) {
        renderIntercom = false;
        //debugger;
        break;
      }
    }
  }
  updateIntercomStatus(renderIntercom);
};

const useIntercomEnabled = () => {
  if (process.browser) {
    let intercomEnabled = true;
    for (let i = 0; i < noIntercomUrls.length; i++) {
      if (window.location.pathname.match(noIntercomUrls[i])) {
        intercomEnabled = false;
        break;
      }
    }
    return intercomEnabled;
  }
  return true;
};

// Component redirects whenever user is not logged in
const IntercomWrapper = () => {
  const router = useRouter();
  const intercomEnabled = useIntercomEnabled();

  const authNeeded = useAdminAuthNeeded(router.asPath);
  const res = useAmILoggedIn({
    query: { retry: 2, enabled: authNeeded && intercomEnabled },
  });

  const { org } = router.query;
  // Use effect to set email/name of current user for intercom
  useEffect(() => {
    if (process.browser && intercomEnabled && authNeeded) {
      let name = "";
      let email = "";

      if (!res.isLoading) {
        if (res.isError) {
          // handle error case;
        } else if (!res.data?.success) {
          // handle error case
        } else {
          name =
            (res.data?.fname ? res.data.fname : "") +
            " " +
            (res.data?.lname ? res.data.lname : "");
          email = res.data?.email ? res.data.email : "";
        }
        setIntercomVars(name, email);
      }
    }
  }, [res.data, org]);

  // Use effect to hide/show intercom depending on page
  useEffect(() => {
    checkPath();
  }, [router.pathname]);

  if (!intercomEnabled) {
    return null;
  }

  return (
    <>
      <Script
        src={"/v2/assets/scripts/intercom.js"}
        strategy="beforeInteractive"
        onLoad={() => {
          checkPath();
        }}
      />
    </>
  );
};

export default IntercomWrapper;
